import { START_LOCATION } from 'vue-router';
import { API_ENDPOINTS } from '@/shared/constants';

const VISITOR_ID_KEY = 'site_visitor_id';

const generateId = () => {
    if (window.crypto?.randomUUID) {
        return window.crypto.randomUUID();
    }

    // Старые браузеры без randomUUID: собираем UUID v4 из getRandomValues
    const bytes = window.crypto.getRandomValues(new Uint8Array(16));

    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    const hex = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');

    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

// Анонимный id браузера: по нему бэк отличает нового посетителя от
// вернувшегося. По IP так не выйдет - весь склад ходит через один офисный IP.
// Если хранилище недоступно (приватный режим и т.п.), id живёт до перезагрузки
// вкладки, такой посетитель просто посчитается новым.
let fallbackVisitorId = null;

const getVisitorId = () => {
    try {
        let id = window.localStorage.getItem(VISITOR_ID_KEY);

        if (!id) {
            id = generateId();
            window.localStorage.setItem(VISITOR_ID_KEY, id);
        }

        return id;
    } catch {
        fallbackVisitorId = fallbackVisitorId || generateId();

        return fallbackVisitorId;
    }
};

/**
 * Сайт одностраничный: переходы между страницами до сервера не доходят,
 * поэтому просмотр отмечаем сами после каждой успешной навигации.
 * Админку не считаем.
 */
export const trackVisit = (to, from, failure) => {
    if (failure || to.path.startsWith('/admin')) {
        return;
    }

    // Смена одних query-параметров на той же странице - не новый просмотр.
    // На первом заходе from это START_LOCATION с тем же path '/', его считаем.
    if (from !== START_LOCATION && to.path === from.path) {
        return;
    }

    try {
        fetch(API_ENDPOINTS.STATS_VISITS, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ visitorId: getVisitorId(), path: to.path }),
            // keepalive, чтобы запрос не обрывался, если человек сразу ушёл со страницы
            keepalive: true,
        }).catch(() => {});
    } catch {
        // Счётчик не должен ломать сайт ни при каких обстоятельствах
    }
};
